import { REAL_PHOTOS } from "../../data/business";
import { CheckCircle2 } from "lucide-react";

const categories = [
  "Residential Floors",
  "Commercial Work Area",
  "Front Counter Refresh",
  "Bathroom Cleaning",
  "Move-Out / Empty Room",
  "General Cleaning Results",
];

export default function BeforeAfter() {
  return (
    <section id="before-after" className="section">
      <div className="container-ss">
        <div className="max-w-2xl">
          <span className="pill mb-3">Real Cleaning Results</span>
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
            Real <span className="text-[#059669]">Cleaning Results</span> from S.S. Cleaning Solutions
          </h2>
          <p className="text-slate-600 mt-3">
            See examples of real residential and commercial cleaning work completed by
            S.S. Cleaning Solutions.
          </p>
        </div>

        <div className="flex flex-wrap gap-2 mt-6">
          {categories.map((c) => (
            <span
              key={c}
              className="pill"
              data-testid={`ba-category-${c.toLowerCase().replace(/[^a-z]/g, "-")}`}
            >
              {c}
            </span>
          ))}
        </div>

        {/* Featured: full Before & After composite from owner */}
        <figure
          className="mt-10 rounded-3xl overflow-hidden border border-slate-200 shadow-sm bg-[#0B1A3F]"
          data-testid="ba-featured-commercial"
        >
          <img
            src={REAL_PHOTOS.beforeAfterCommercial}
            alt="S.S. Cleaning Solutions before and after commercial cleaning results"
            className="w-full h-auto block"
            loading="lazy"
          />
          <figcaption className="px-5 py-3 text-sm text-white/90 flex items-center gap-2">
            <CheckCircle2 size={14} className="text-emerald-300" />
            Commercial Cleaning Results — front counter, workbench, shop floor & restroom
          </figcaption>
        </figure>

        {/* 3-up grid of real project photos */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-6">
          <ProjectCard
            src={REAL_PHOTOS.workAreaReset}
            title="Work Area Reset"
            sub="Before · During · After"
            testid="ba-work-area"
          />
          <ProjectCard
            src={REAL_PHOTOS.frontCounter}
            title="Front Counter Refresh"
            sub="Commercial shop counter & floors"
            testid="ba-front-counter"
          />
          <ProjectCard
            src={REAL_PHOTOS.workshopDetail}
            title="Workshop Detail"
            sub="Tools, counters & service area"
            testid="ba-workshop"
          />
        </div>
      </div>
    </section>
  );
}

function ProjectCard({ src, title, sub, testid }) {
  return (
    <figure
      className="relative rounded-3xl overflow-hidden border border-slate-200 bg-white"
      data-testid={testid}
    >
      <img
        src={src}
        alt={title}
        className="w-full h-[260px] object-cover"
        loading="lazy"
      />
      <figcaption className="px-4 py-3">
        <div className="font-display font-semibold text-slate-900">{title}</div>
        <div className="text-xs text-slate-500 mt-0.5">{sub}</div>
      </figcaption>
    </figure>
  );
}
